import React from 'react';
import { View } from 'react-native-web';

//= ========================================================================

const StepPoint = ({
  globJSON, backgroundColor = globJSON.configurations.theme.colors.tertiary_icons_color,
}) => (
  <View
    style={{
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor,
    }}
  />
);
export default StepPoint;
